import Parse from "../../api/ApiConfig";
// API utils functions
const requestHeaders = {
	"X-Parse-Application-Id": "FortCore",
};

// Fetch lease table data (ongoing, submitted, completed, created_assets, savings)
export const fetchEducationData = async (category) => {
	try {
		if (category) {
			const Education = Parse.Object.extend("Education");
			const query = new Parse.Query(Education);
			query.equalTo("courseType", category);
			const results = await query.find();
			return results ? results : [];
		} else return [];
	} catch (error) {
		console.log(error);
		return [];
	}
};

export const fetchSingleAudio = async (id) => {
	try {
		if (id) {
			const Education = Parse.Object.extend("Education");
			const query = new Parse.Query(Education);
			query.equalTo("objectId", id);
			const results = await query.find();
			return results ? results : {};
		} else return {};
	} catch (error) {
		console.log(error);
		return {};
	}
};

export const fetchSingleBook = async (id) => {
	try {
		if (id) {
			const Education = Parse.Object.extend("Education");
			const query = new Parse.Query(Education);
			query.equalTo("objectId", id);
			const results = await query.find();
			return results ? results : {};
		} else return {};
	} catch (error) {
		console.log(error);
		return {};
	}
};

export const fetchSingleVideo = async (id) => {
	try {
		if (id) {
			const Education = Parse.Object.extend("Education");
			const query = new Parse.Query(Education);
			query.equalTo("objectId", id);
			const results = await query.find();
			return results ? results : {};
		} else return {};
	} catch (error) {
		console.log(error);
		return {};
	}
};

export const contentProps = {
	name: "file",
	showUploadList: { showRemoveIcon: false },
	progress: {
		strokeColor: {
			"0%": "#000000",
			"100%": "#000000",
		},
	},

	maxCount: 1,
};

export const generateId = () => {
	return Math.floor(Math.random() * Date.now()).toString(16);
};

export const formatDuration = (seconds) => {
	const minutes = Math.floor(seconds / 60);
	const remainingSeconds = Math.floor(seconds % 60);
	return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};

export const fetchChartData = async () => {
	try {
		const url =
			process.env.REACT_APP_SERVER_URL + "/functions/getEducationAnalysis";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			// console.log(res)
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const approveMultipleContent = async (contentIds, sessionToken) => {
	const customHeaders = {
		"X-Parse-Application-Id": "FortCore",
		"X-Parse-Session-Token": `${sessionToken}`,
	};
	let requestBody = { ids: contentIds };
	// console.log(customHeaders)
	try {
		const response = await fetch(
			`${Parse.serverURL}/functions/approveEducation`,
			{
				method: "POST",
				headers: customHeaders,
				body: JSON.stringify(requestBody),
			}
		);
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};
